import { useEffect, useRef, useState } from "react";
import Input from "../components/common/Input";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CardCryptoWallet from "../components/features/CardCryptoWallet";
import CardBankWallet from "../components/features/CardBankWallet";
import Popup from "../components/common/Popup";
import AddCryptoWalletForm from "../components/features/AddCryptoWalletForm";
import AddBankWalletForm from "../components/features/AddBankWalletForm";
import Select from "../components/common/Select";
import i18n from "../language/i18n";
import KYC from '../assets/images/KYC.svg';
import KYCLOGO from '../assets/images/logoKYC.svg';

import {
  fetchChangesEmail,
  fetchChangesPhone,
  fetchSendCode,
  fetchSendCodePhone,
  fetchUpdateUserData,
} from "./FetchUpdateUserData";
import { updateUserInfo } from "../store/actions/userAction";
import sendImg from "../assets/images/send-code.svg";
import sendPhoneImg from "../assets/images/send-code-phone.svg";
import { fetchUpdate } from "../routes/FetchData";
import VerificationUser from "../components/features/VerificationUser";
import PhoneInput from "react-phone-input-2";

const Settings = () => {
  const { t } = useTranslation();
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };
  // --- START --- FORM USER INFO --- START ---
  const userInfo = useSelector((state) => state.user); // get user info from store
  const dispatch = useDispatch();
  const [fname, setfname] = useState(userInfo.fname);
  const mname = userInfo.mname;
  const [lname, setlname] = useState(userInfo.lname);
  const [phoneNumber, setPhoneNumber] = useState(userInfo.phone);
  const [email, setEmail] = useState(userInfo.email);
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [changesEmailPassword, setChangesEmailPassword] = useState("");
  const [code, setCode] = useState("");

  const [errors, setErrors] = useState({
    // set errors
    fname: "",
    lname: "",
    email: "",
    phoneNumber: "",
    password: "",
    newPassword: "",
    changesEmailPassword: "",
    code: "",
    codePhoneNumber: "",
  });
  const [state, setState] = useState("normal");
  const [statePassword, setStatePassword] = useState(state);
  const [stateNewPassword, setStateNewPassword] = useState(state);
  const stateEmail = state;
  const statePhoneNumber = state;
  const [stateChangesEmailPassword, setStateChangesEmailPassword] =
    useState(state);
  const [stateCode, setStateCode] = useState(state);
  const newPasswordRef = useRef(null);





  const resetErrors = () => {
    // reset errors
    setErrors((prevErrors) => ({
      ...prevErrors,
      fname: "",
      lname: "",
      email: "",
      phoneNumber: "",
    }));
    setState("normal");
  };

  const handleEmailChange = (e) => {
    // handle email change
    setEmail(e.target.value);
    resetErrors();
  };

  const handleChangesEmailPassword = (e) => {
    setChangesEmailPassword(e.target.value);
    resetErrors();
  };

  const handlePasswordChange = (e) => {
    // handle password change
    setPassword(e.target.value);
    setStatePassword("normal");
    setStateNewPassword("normal");
    setErrors((prevErrors) => ({
      ...prevErrors,
      password: "",
      newPassword: "",
    }));
    resetErrors();

    if (e.target.value === newPassword && newPassword) {
      // check if passwords match
      setStateNewPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        newPassword: t("Passwords do match."),
      }));
    }
  };

  const handlefnameChange = (e) => {
    // handle first name change
    setfname(e.target.value);
    resetErrors();
  };

  const handleCode = (e) => {
    setCode(e.target.value);
    resetErrors();
  };

  const handlelnameChange = (e) => {
    // handle last name change
    setlname(e.target.value);
    resetErrors();
  };

  const handlePhoneNumberChange = (e) => {
    // handle phone number change
    setPhoneNumber(e.target.value);
    resetErrors();
  };

  const [validatePassword, setValidatePassword] = useState(false);

  const handleNewPasswordChange = (e) => {
    // handle confirm password change
    setNewPassword(e.target.value);
    setStateNewPassword("normal");
    setErrors((prevErrors) => ({
      ...prevErrors,
      newPassword: "",
    }));
    resetErrors();

    if (e.target.value.length < 8) {
      // check if the password is at least 8 characters long
      setStateNewPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        newPassword: t("The password must be at least 8 characters long."),
      }));
      setValidatePassword(false);
    } else if (!/[A-Z]/.test(e.target.value)) {
      // check if the password contains at least one capital letter
      setStateNewPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        newPassword: t(
          "The password must contain at least one capital letter."
        ),
      }));
      setValidatePassword(false);
    } else if (!/[a-z]/.test(e.target.value)) {
      // check if the password contains at least one lowercase letter
      setStateNewPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        newPassword: t(
          "The password must contain at least one lowercase letter."
        ),
      }));
      setValidatePassword(false);
    } else if (!/\d/.test(e.target.value)) {
      // check if the password contains at least one digit
      setStateNewPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        newPassword: t("The password must contain at least one digit."),
      }));
      setValidatePassword(false);
    } else if (e.target.value === password && e.target.value !== "") {
      // check if passwords match
      setStateNewPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        newPassword: t("Passwords do match."),
      }));
      setValidatePassword(false);
    } else {
      setValidatePassword(true);
    }
  };

  const convertPhoneNumber = (phoneNumber) => {
    // Function to convert phone number to digits only
    const digitsOnly = phoneNumber.replace(/\D/g, "");
    return digitsOnly;
  };

  const [sendCode, setSendCode] = useState(false);
  const sendCodeHandler = (password) => {
    setStateChangesEmailPassword("normal");
    fetchChangesEmail(userInfo.id, email, password).then((data) => {
      if (data.status === 200) {
        setSendCode(true);
      } else if (data.status === 409) {
        setStateChangesEmailPassword("error");
        setErrors((prevErrors) => ({
          ...prevErrors,
          changesEmailPassword: t("This email has already been registered."),
        }));
      } else {
        setStateChangesEmailPassword("error");
        setErrors((prevErrors) => ({
          ...prevErrors,
          changesEmailPassword: t("Invalid password."),
        }));
      }
    });
  };
  const handleSendCode = (e) => {
    e.preventDefault();
    sendCodeHandler(changesEmailPassword);
  };

  const handleChangesEmail = (e) => {
    e.preventDefault();
    fetchSendCode(userInfo.id, code).then((data) => {
      if (data.susscess) {
        setIsPopupOpenSuccessful(true);
        closePopupChangesEmail();
        const newData = { ...userInfo, email: email };
        updateUserInfo(dispatch, newData);
      } else if (data.susscess === 409) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          password: t("This email has already been registered."),
        }));
        setStatePassword("error");
      } else {
        setStateCode("error");
        setErrors((prevErrors) => ({
          ...prevErrors,
          code: t("Invalid code."),
        }));
      }
    });
  };

  // --- END --- FORM USER INFO --- END ---

  // --- START --- FORM WALLETS --- START ---
  // crypto wallets
  const cryptoWalletsInfo = useSelector(
    (state) => state.cryptoWallets.cryptoWallets // get crypto wallets info from store
  );
  const [isPopupOpenCrypto, setIsPopupOpenCrypto] = useState(false);
  const [isPopupOpenSuccessful, setIsPopupOpenSuccessful] = useState(false);
  const [isPopupOpenChangesEmail, setIsPopupOpenChangesEmail] = useState(false);

  const openPopupCrypto = () => setIsPopupOpenCrypto(true);
  const closePopupChangesEmail = () => {
    setIsPopupOpenChangesEmail(false);
    setSendCode(false);
  };
  const closePopupCrypto = () => setIsPopupOpenCrypto(false);
  const closePopupSuccessful = () => setIsPopupOpenSuccessful(false);
  // bank wallets
  const bankWalletsInfo = useSelector((state) => state.bankWallets.bankWallets);
  const [isPopupOpenBank, setIsPopupOpenBank] = useState(false);
  const openPopupBank = () => setIsPopupOpenBank(true);
  const closePopupBank = () => setIsPopupOpenBank(false);
  // --- END --- FORM WALLETS --- END ---

  // NEW CODE

  const formChangePass = (e) => {
    e.preventDefault();
    fetchUpdateUserData(userInfo.id, {
      old_password: password,
      new_password: newPassword,
    }).then((data) => {
      if (data) {
        setIsPopupOpenSuccessful(true);
        setNewPassword("");
        setPassword("");
      } else if (data === false) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          password: t("Invalid password."),
        }));
        setStatePassword("error");
        setValidatePassword(false);
      } else {
        console.log("Error");
      }
    });
  };

  const [isPopupOpenChangesPhoneNumber, setIsPopupOpenChangesPhoneNumber] = useState(false);
  const closePopupChangesPhoneNumber = () => { setIsPopupOpenChangesPhoneNumber(false); setSendCodePhoneNumber(false) };
  const [changesPhoneNumberPassword, setChangesPhoneNumberPassword] = useState("");
  const [codePhoneNumber, setCodePhoneNumber] = useState("");
  const [sendCodePhoneNumber, setSendCodePhoneNumber] = useState(false);
  const [statePhoneNumberPassword, setStatePhoneNumberPassword] = useState(state);
  const [stateCodePhoneNumber, setStateCodePhoneNumber] = useState(state);
  const handlePhoneNumberPassword = (e) => {
    setChangesPhoneNumberPassword(e.target.value);
    resetErrors();
  };

  const handleSendCodePhoneNumber = (e) => {
    e.preventDefault();
    fetchChangesPhone(userInfo.id, `+${convertPhoneNumber(phoneNumber)}`, changesPhoneNumberPassword).then((data) => {
      if (data.status === 200) {
        setSendCodePhoneNumber(true);
      } else {
        setStatePhoneNumberPassword("error");
        setErrors((prevErrors) => ({
          ...prevErrors,
          changesPhoneNumberPassword: t("Invalid password."),
        }));
      }
    });
  }

  const handleCodePhoneNumber = (e) => {
    setCodePhoneNumber(e.target.value);
    resetErrors();
  }

  const handleChangesPhoneNumber = (e) => {
    e.preventDefault();
    fetchSendCodePhone(userInfo.id, codePhoneNumber, `+${convertPhoneNumber(phoneNumber)}`).then((data) => {
      if (data.susscess) {
        setIsPopupOpenSuccessful(true);
        closePopupChangesPhoneNumber();
        const newData = { ...userInfo, phone: phoneNumber };
        updateUserInfo(dispatch, newData);
      } else {
        setStateCodePhoneNumber("error");
        setErrors((prevErrors) => ({
          ...prevErrors,
          codePhoneNumber: t("Invalid code."),
        }));
      }
    });
  }
  // verification sumsub KYC
  const [isPopupOpenVerification, setIsPopupOpenVerification] = useState(false);
  const [token, setToken] = useState("none");
  const openSumsub = () => {
    fetchUpdate(userInfo.verif + 1).then((data) => {
      if (data) {
        setToken(data.token);
        setTimeout(() => {
          setIsPopupOpenVerification(true);
        }, 1000);
      } else {
        console.log("Error");
      }
    }
    );
  }

  const [isPopupOpenLimit, setPopupOpenIsLimit] = useState(userInfo.verif === 0 && userInfo.type === 0);

  useEffect(() => {
    setPopupOpenIsLimit(userInfo.verif === 0 && userInfo.type === 0)
  }, [userInfo.verif, userInfo.type])


  return (
    <div className="settings">
      <VerificationUser token={token} isPopupOpenVerification={isPopupOpenVerification} setIsPopupOpenVerification={setIsPopupOpenVerification} />

      <Popup isOpen={isPopupOpenLimit} onClose={() => null}>
        <div className="view-details">
          <h3 className="px-32">{t("Exchange is unavailable until your identity is verified")}</h3>
          <img src={KYC} alt="" />
          <div className="wrapper-buttons">
            <button onClick={() => openSumsub()} className="blue-button">
              {t("Start Verifying")}
            </button>
          </div>
        </div>
      </Popup>


      {/* --- START --- POPUP FORMS --- START --- */}
      <Popup isOpen={isPopupOpenSuccessful} onClose={closePopupSuccessful}>
        <div className="popup-content">
          <h3>{t("Changes successfully saved!")}</h3>
          <button
            onClick={closePopupSuccessful}
            className="form-default__submit"
          >
            {t("Continue")}
          </button>
        </div>
      </Popup>

      <Popup isOpen={isPopupOpenChangesEmail} onClose={closePopupChangesEmail}>
        {!sendCode ? (
          <form onSubmit={handleSendCode} className="popup-content">
            <h3>{t("Please enter your password to continue")}</h3>
            <Input
              id="password-changes-email"
              label={t("Current password")}
              type="password"
              value={changesEmailPassword}
              onChange={handleChangesEmailPassword}
              placeholder={t("Enter password")}
              state={stateChangesEmailPassword}
              alertState={errors.changesEmailPassword}
              required
            />
            <button type="submit" className="form-default__submit">
              {t("Continue")}
            </button>
            <button
              onClick={closePopupChangesEmail}
              type="button"
              className="closed-button"
            >
              <i className="ri-close-large-line"></i>
            </button>
          </form>
        ) : (
          <form onSubmit={handleChangesEmail} className="popup-content">
            <h3>{t("Check your email")}</h3>
            <img src={sendImg} alt="" />
            <p className="popup-paragraf">
              {t("Enter the 6-digit code we just sent to ")}{" "}
              <span>{email}</span> {t(" to continue")}
            </p>
            <Input
              id="code"
              label={t("Email code")}
              type="text"
              value={code}
              onChange={handleCode}
              placeholder={t("6-digit code")}
              state={stateCode}
              alertState={errors.code}
              required
            />
            <button type="submit" className="form-default__submit">
              {t("Continue")}
            </button>

            <button
              onClick={closePopupChangesPhoneNumber}
              type="button"
              className="closed-button"
            >
              <i className="ri-close-large-line"></i>
            </button>
          </form>
        )}
      </Popup>

      <Popup isOpen={isPopupOpenChangesPhoneNumber} onClose={closePopupChangesPhoneNumber}>
        {!sendCodePhoneNumber ? (
          <form onSubmit={handleSendCodePhoneNumber} className="popup-content">
            <h3>{t("Please enter your password to continue")}</h3>
            <Input
              id="password-changes-phone"
              label={t("Current password")}
              type="password"
              value={changesPhoneNumberPassword}
              onChange={handlePhoneNumberPassword}
              placeholder={t("Enter password")}
              state={statePhoneNumberPassword}
              alertState={errors.changesPhoneNumberPassword}
              required
            />
            <button type="submit" className="form-default__submit">
              {t("Continue")}
            </button>
            <button
              onClick={closePopupChangesPhoneNumber}
              type="button"
              className="closed-button"
            >
              <i className="ri-close-large-line"></i>
            </button>
          </form>
        ) : (
          <form onSubmit={handleChangesPhoneNumber} className="popup-content">
            <h3>{t("Check your phone")}</h3>
            <img src={sendPhoneImg} alt="" />
            <p className="popup-paragraf">
              {t("Enter the 6-digit code that we just sent to the phone number")}{" "}
              <span>{phoneNumber}</span> {t(" to continue")}
            </p>
            <Input
              id="code"
              label={t("Phone code")}
              type="text"
              value={codePhoneNumber}
              onChange={handleCodePhoneNumber}
              placeholder={t("6-digit code")}
              state={stateCodePhoneNumber}
              alertState={errors.codePhoneNumber}
              required
            />
            <button type="submit" className="form-default__submit">
              {t("Continue")}
            </button>

            <button
              onClick={closePopupChangesPhoneNumber}
              type="button"
              className="closed-button"
            >
              <i className="ri-close-large-line"></i>
            </button>
          </form>
        )}
      </Popup>

      <Popup isOpen={isPopupOpenCrypto} onClose={closePopupCrypto}>
        <AddCryptoWalletForm closePopup={closePopupCrypto} />
      </Popup>
      <Popup isOpen={isPopupOpenBank} onClose={closePopupBank}>
        <AddBankWalletForm closePopup={closePopupBank} />
      </Popup>
      {/* --- END --- POPUP FORMS --- END --- */}
      <h1 className="heading">{t("Profile settings")}</h1>
      {/** onSubmit={handleSubmit} */}
      <div style={{ width: "100%" }} className="mt-20">
        <div className="form-default grid-column">
          <form className="grid-columns-2" onSubmit={formChangePass}>
            <h3 className="grid-column-span-2">{t("User info")}</h3>
            <div className="form-settings-input-container grid-column-span-2">
              <Input
                id="first-name"
                label={t("First Name")}
                type="text"
                value={fname}
                onChange={handlefnameChange}
                placeholder={t("Enter first name")}
                state={state}
                disabled={true}
                style={{ width: "100%" }}
              />
              {mname ? <Input
                id="midle-name"
                label={t("midle Name")}
                type="text"
                value={mname}
                onChange={handlefnameChange}
                placeholder={t("Enter midle name")}
                state={state}
                disabled={true}
                style={{ width: "100%" }}
              /> : null}
              <Input
                id="last-name"
                label={t("Last Name")}
                type="text"
                value={lname}
                onChange={handlelnameChange}
                placeholder={t("Enter last name")}
                state={state}
                disabled={true}
                style={{ width: "100%" }}
              />
            </div>
            {userInfo.type !== 1 ? <Input
              id="password"
              label={t("Current password")}
              type="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder={t("Enter password")}
              state={statePassword}
              alertState={errors.password}
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\\\\d)[A-Za-z\\\\d@$!%*?&-_{[}]]]{8,}$"
            /> : null}

            {userInfo.type !== 1 ? <Input
              id="confirm-password"
              label={t("New password")}
              type="password"
              value={newPassword}
              onChange={handleNewPasswordChange}
              placeholder={t("Enter new password")}
              state={stateNewPassword}
              alertState={errors.newPassword}
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\\\\d)[A-Za-z\\\\d@$!%*?&-_{[}]]]{8,}$"
              ref={newPasswordRef}
            /> : null}

            {userInfo.type !== 1 ? <button
              className="form-default__submit grid-column-span-2"
              type="submit"
              style={
                password !== "" || newPassword !== ""
                  ? { display: "flex" }
                  : { display: "none" }
              }
              disabled={!validatePassword}
            >
              {t("Save edits")}
            </button> : null}
          </form>
          {userInfo.type !== 1 ? <div className="line-form"></div> : null}
          {userInfo.type !== 1 ? <div className="grid-columns-2">
            <h3 className="grid-column-span-2">{t("Contact info")}</h3>
            <Input
              id="email"
              label={t("Email")}
              type="code"
              value={email}
              onChange={handleEmailChange}
              placeholder={t("Enter email")}
              state={stateEmail}
              alertState={errors.email}
              action={() => setIsPopupOpenChangesEmail(true)}
              textAction={t("Change")}
              activeAction={email === userInfo.email}
              titleAction={phoneNumber === userInfo.phone ? t("Enter your new email to continue") : t("change email")}
            />
            <Input
              id="phone-number"
              label={t("Phone number")}
              type="code"
              subType="tel"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              placeholder="+__ (___)-___-__-__"
              state={statePhoneNumber}
              alertState={errors.phoneNumber}
              action={() => setIsPopupOpenChangesPhoneNumber(true)}
              textAction={t("Change")}
              activeAction={phoneNumber === userInfo.phone}
              titleAction={phoneNumber === userInfo.phone ? t("Enter your new phone number to continue") : t("change phone number")}
            />


            {/* <div className="component-input">
              <label htmlFor="phone-number">{t("Phone number")}</label>

              <div>
                <PhoneInput
                  country={'us'}
                  value={phoneNumber}
                  onChange={phoneNumber => setPhoneNumber(phoneNumber)}
                  enableSearch={true}
                />
                <button
                  type="button"
                  onClick={phoneNumber === userInfo.phone ? () => submit_action() : null}
                  className={`input__submit ${statePhoneNumber}`}
                  disabled={phoneNumber === userInfo.phone}
                  title={t("Change")}
                >
                  <p>
                  {t("Change")}
                  </p>
                </button>
              </div>


              {errors.phoneNumber && <p className={statePhoneNumber}>{errors.phoneNumber}</p>}
            </div> */}
          </div> : null}
        </div>
      </div>

      {userInfo.type === 1 ? null : (
        <div className="form-default flex-column">
          <h3>{t("Crypto Wallets")}</h3>
          {cryptoWalletsInfo.map((wallet, index) =>
            wallet.visib === 1 ? (
              <CardCryptoWallet key={wallet.key} num={index} wallet={wallet} />
            ) : null
          )}
          <button onClick={openPopupCrypto} className="add-wallet">
            <i className="ri-add-circle-line"></i>
            {t("Add new Crypto wallet")}
          </button>
        </div>
      )}

      {userInfo.type === 1 ? null : (
        <div className="form-default flex-column">
          <h3>{t("Bank Accounts")}</h3>
          {bankWalletsInfo.map((account) =>
            account.visib === 1 ? (
              <CardBankWallet key={account.key} account={account} />
            ) : null
          )}
          <button onClick={openPopupBank} className="add-wallet">
            <i className="ri-add-circle-line"></i>
            {t("Add new Wallet")}
          </button>
        </div>
      )}

      {/* {userInfo.type === 0 ? (userInfo.verif === 1) ? (
        <div className="form-default flex-column">
          <h3>{t("Verification(KYC)")}</h3>
          <div className="white-stroke flex-row">
            <h4>{t("Verification passed")}</h4>

            <div className="flex-row">
              <p className="only-desktop">{t("Approved")}</p>
              <img src={KYCLOGO} alt="" />
            </div>
          </div>
        </div>
      ) : (
        <div className="form-default flex-column">
          <h3>{t("Verification(KYC)")}</h3>
          <div className="white-block flex-row">
            <div className="flex-column">
              <h4>{t("Upgrade your limit up to")}</h4>
              <p>{t("10,000.00€")}</p>
            </div>
            <img src={KYC} alt="" />
          </div>
          <button onClick={() => openSumsub()} className="blue-button">{t("Start Verification")}</button>
        </div>
      ) : null} */}
      <div className="form-default flex-column">
        <h3>{t("Language")}</h3>
        <div className="language-wrapper">
          <p>{t("Select your language")}</p>
          <Select
            options={[
              "English (US)",
              "Deutsch (DE)",
              "Українська (UA)",
              "Slovenský (SK)",
            ]}
            actions={[
              () => changeLanguage("en"),
              () => changeLanguage("de"),
              () => changeLanguage("ua"),
              () => changeLanguage("sk"),
            ]}
            defaultOption={
              i18n.language === "sk"
                ? 3
                : i18n.language === "de"
                  ? 1
                  : i18n.language === "ua"
                    ? 2
                    : 0
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Settings;
